import { z } from 'zod'

import { VISA_TYPE_MAP } from '@/lib/queries/business/constants'

export const formSchema = z
  .object({
    assignees: z.string().array().optional(),
    categoryId: z.string(),
    categoryName: z.string(),
    visaType: z.union([z.literal(VISA_TYPE_MAP.immigrant), z.literal(VISA_TYPE_MAP['non-immigrant'])]),
    location: z.string(),
    caseNumber: z.string(),
    tags: z
      .string()
      .optional()
      .refine(
        (tags) => {
          const split = tags?.split(/\s*,\s*/)
          const validTags = split?.filter((x) => x.trim().length > 0) ?? []
          return validTags.length <= 5
        },
        {
          message: 'You can only add up to 5 tags.',
        }
      ),
    passportNumber: z.string().optional(),
    surname: z.string().optional(),
    isSkipActivated: z.boolean(),
    isPublic: z.boolean(),
  })
  .refine(
    (data) => {
      // NOTE: "add-category" is an ad-hoc value defined and used in
      // client-side to represent the status of adding new category. That is, if
      // the value is "add-category", category name must be provided.
      if (data.categoryId === 'add-category' && !data.categoryName) {
        return false
      }
      return true
    },
    {
      message: 'Required',
      path: ['categoryName'],
    }
  )
